import { useNavigate } from 'react-router-dom';

import { appColors, ActionStickerCard, ImageCard } from '@backrs_ui/common-ui';

import { BadgeCircle } from '@backrs_ui/common-ui/src/atoms/BadgeCircle';
import { LubavTool } from '@backrs_ui/grow-ui/src/models/models';
import {
  useToolCardById,
  StickerCardId,
  ImageCardId,
} from '@backrs_ui/grow-ui/src/pages/Home/hooks/stickerCardMapping';

import { Box, Theme, SxProps, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

interface ToolNuggetProps {
  tool: LubavTool;
}

export const ToolNugget = ({ tool }: ToolNuggetProps) => {
  const navigate = useNavigate();
  const { getStickerCard, getImageCard } = useToolCardById({ navigate });

  const stickerCard = getStickerCard(tool.id as StickerCardId);
  const imageCard = getImageCard(tool.id as ImageCardId);

  if (!stickerCard && !imageCard) return null;

  return (
    <Box sx={toolItemStyles}>
      <Box sx={contentContainerStyle}>
        <Box sx={stickerCardContainerStyle}>
          {stickerCard ? <ActionStickerCard {...stickerCard} /> : <ImageCard {...imageCard} />}
        </Box>
        <Box sx={relevanceContainerStyle}>
          <Typography sx={relevanceWrapperStyle}>
            <Box mt={0.5}>
              <BadgeCircle />
            </Box>
            <ReactMarkdown
              components={{
                p: ({ ...props }) => <p style={{ margin: '0px' }} {...props} />,
              }}
            >
              {tool.relevance}
            </ReactMarkdown>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const stickerCardContainerStyle: SxProps<Theme> = {
  width: '100%',
  paddingX: 2,
  paddingY: 2,
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'row',
};

const toolItemStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  border: '1px solid black',
  borderRadius: '8px',
  width: '100%',
  backgroundColor: '#FFFFFF',
};

const contentContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  '@media (min-width: 1300px)': {
    flexDirection: 'row',
  },
};

const relevanceContainerStyle: SxProps<Theme> = {
  display: 'flex',
  borderTop: `1px solid ${appColors.neutral.gray4}`,
  flexDirection: 'column',
  width: '100%',
  '@media (min-width: 1300px)': {
    width: '50%',
    borderLeft: `1px solid ${appColors.neutral.gray4}`,
    borderTop: 'none',
    margin: '0px 16px',
  },
  '@media (min-width: 1450px)': {
    width: '75%',
  },
  '@media (min-width: 1600px)': {
    width: '100%',
  },
};

const relevanceWrapperStyle: SxProps<Theme> = {
  fontSize: '10pt',
  width: '100%',
  boxSizing: 'border-box',
  color: appColors.neutral.charcoal,
  fontStyle: 'italic',
  paddingY: 2,
  paddingX: 2,
  display: 'flex',
  flexDirection: 'row',
  gap: 1,
};
